import { render, staticRenderFns } from "./ModalTableComponent.vue?vue&type=template&id=5290ff58&scoped=true"
import script from "./ModalTableComponent.vue?vue&type=script&lang=js"
export * from "./ModalTableComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalTableComponent.vue?vue&type=style&index=0&id=5290ff58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5290ff58",
  null
  
)

export default component.exports